import React from 'react'
import { Typography, Input, Row, Col, Form, Collapse, Space, Button } from 'antd'
import PropTypes from 'prop-types'
import { ImageUploader } from '~components'
import styles from './MediaRow.module.css'

const MediaRow = ({
  media,
  setMedia
}) => {
  const { Title } = Typography
  const { Panel } = Collapse

  const deleteMediaRow = (event, index) => {
    event.stopPropagation()
    const clonedMedia = [...media]
    if (index !== -1) {
      clonedMedia.splice(index, 1)
    }
    setMedia(clonedMedia)
  }

  const handleCTANameChange = (event, index) => {
    const temp = [...media]
    temp[index] = {
      ...temp[index],
      title: event.target.value
    }
    setMedia([...temp])
  }
  const handleCTAUrlChange = (event, index) => {
    const temp = [...media]
    temp[index] = {
      ...temp[index],
      url: event.target.value
    }
    setMedia([...temp])
  }
  const handleIconChange = (imgObj, index) => {
    const temp = [...media]
    temp[index] = {
      ...temp[index],
      icon: imgObj
    }
    setMedia([...temp])
  }
  const handleIconUrlChange = (secureImageURL, index) => {
    const temp = [...media]
    temp[index] = {
      ...temp[index],
      icon: { ...temp[index].icon, url: secureImageURL }
    }
    setMedia([...temp])
  }

  return (
    <div className={styles['media-row-container']}>
      <Collapse accordion defaultActiveKey={['0']} expandIconPosition='right' style={{ width: '100%' }}>
        {media?.map((media, rowIndex) => (<Panel key={rowIndex}
          extra={<Row gutter={2}><Space>
            <Button danger onClick={(event) => deleteMediaRow(event, rowIndex)} style={{ backgroundColor: '#DA0D50', color: '#fff' }}>Delete</Button>
          </Space>
          </Row>
          }
          header={<span style={{ fontSize: 20 }}>{media?.title}</span>}>
          <Row align={'left'} className={styles['title-wrapper']}>
            <Col><Title level={3}>Label*</Title></Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item><Input onChange={(event) => handleCTANameChange(event, rowIndex)} value={media?.title}/></Form.Item>
            </Col>
          </Row>
          {media && !media.title && <Typography.Paragraph className={styles['paragraph-text']}>Please fill out this field</Typography.Paragraph>}
          <Row align={'left'} className={styles['title-wrapper']}>
            <Col><Title level={3}>Call-to-Action URL*</Title></Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item><Input onChange={(event) => handleCTAUrlChange(event, rowIndex)} value={media?.url}/></Form.Item>
            </Col>
          </Row>
          {media && !media.url && <Typography.Paragraph className={styles['paragraph-text']}>Please fill out this field</Typography.Paragraph>}
          <br />
          <Row align={'left'} className={styles['title-wrapper']} gutter={[10, 10]}>
            <Col><Title level={3}>Media Icon</Title></Col>
            <Col><Title level={4}> (Upload PNG or JPG; preferred dimensions 0px x 0px; max file size 1MB)</Title></Col>
          </Row>
          <Row>
            <Col span={24}>
              <ImageUploader alt={media?.icon?.alt} handleIconChange ={(imageObj) => handleIconChange(imageObj, rowIndex)} handleUpload={(imageUrl) => handleIconUrlChange(imageUrl, rowIndex)} logoUrl={media?.icon?.url} />
            </Col>
          </Row>
          <br />
        </Panel>))
        }
      </Collapse>
    </div>
  )
}
MediaRow.propTypes = {
  deleteMediaRow: PropTypes.func,
  media: PropTypes.array,
  setMedia: PropTypes.func
}

export default MediaRow
